export const reportsWeeklyData = [
  { week: '10-16 Şub', revenue: 48200, leads: 128, conversions: 98, visitors: 7200 },
  { week: '17-23 Şub', revenue: 52400, leads: 142, conversions: 112, visitors: 8100 },
  { week: '24 Şub-2 Mar', revenue: 58900, leads: 156, conversions: 124, visitors: 9000 },
  { week: '3-9 Mar', revenue: 61200, leads: 168, conversions: 138, visitors: 9800 },
  { week: '10-16 Mar', revenue: 68400, leads: 187, conversions: 152, visitors: 11200 },
];

export const reportsMonthlyData = [
  { month: 'Eki', revenue: 142000, leads: 380, conversions: 310 },
  { month: 'Kas', revenue: 168000, leads: 440, conversions: 362 },
  { month: 'Ara', revenue: 195000, leads: 510, conversions: 418 },
  { month: 'Oca', revenue: 178000, leads: 472, conversions: 385 },
  { month: 'Şub', revenue: 214000, leads: 558, conversions: 454 },
  { month: 'Mar', revenue: 228000, leads: 621, conversions: 510 },
];

export const topCampaignReport = [
  { rank: 1, campaign: 'Botoks & Dolgu Paketi', revenue: 68400, leads: 342, convRate: 8.0, avgRevenue: 200 },
  { rank: 2, campaign: 'Hydra Facial Gençlik', revenue: 54200, leads: 201, convRate: 9.6, avgRevenue: 270 },
  { rank: 3, campaign: 'Komple SPA Günü', revenue: 48600, leads: 274, convRate: 8.6, avgRevenue: 177 },
  { rank: 4, campaign: 'Lazer Epilasyon 6 Seans', revenue: 43200, leads: 218, convRate: 6.0, avgRevenue: 198 },
  { rank: 5, campaign: 'Dermapen Cilt Yenileme', revenue: 38800, leads: 189, convRate: 7.7, avgRevenue: 205 },
];

export const comparisonData = {
  thisWeek: { visitors: 11240, leads: 187, conversions: 152, revenue: 68400 },
  lastWeek: { visitors: 9800, leads: 168, conversions: 138, revenue: 61200 },
  thisMonth: { visitors: 42800, leads: 621, conversions: 510, revenue: 228000 },
  lastMonth: { visitors: 38400, leads: 558, conversions: 454, revenue: 214000 },
};

export const sourceReportData = [
  { source: 'Google Ads', leads: 272, revenue: 124000, roi: 320 },
  { source: 'Instagram', leads: 174, revenue: 78400, roi: 280 },
  { source: 'Facebook', leads: 98, revenue: 44200, roi: 195 },
  { source: 'Organik', leads: 62, revenue: 31800, roi: 0 },
  { source: 'TikTok', leads: 34, revenue: 15200, roi: 240 },
];
